/** Канонический список препаратов Novacutan (чекбоксы / нормализация). */
export const CANONICAL_MEDICATION_NAMES = [
  'Novacutan BTA',
  'Novacutan BioPRO',
  'Novacutan Bright',
  'Novacutan Eye',
  'Novacutan FBio',
  'Novacutan FBio DVS',
  'Novacutan FBio DVS Light',
  'Novacutan FBio DVS Medium',
  'Novacutan FBio DVS Volume',
  'Novacutan FBio Light',
  'Novacutan FBio Medium',
  'Novacutan FBio Volume',
  'Novacutan Gentle',
  'Novacutan Master',
  'Novacutan PLA',
  'Novacutan Prima',
  'Novacutan SBio',
  'Novacutan YBio',
];

export const splitMedicationTokens = (value) => {
  if (!value) return [];
  return String(value)
    .replace(/\n/g, ',')
    .replace(/;/g, ',')
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
};

export const joinMedicationTokens = (names) =>
  (names || []).filter(Boolean).join('\n');

export const normalizeMedicationKey = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9а-яё]/gi, '')
    .trim();

export const parseSelectedMedications = (value, catalogNames = CANONICAL_MEDICATION_NAMES) => {
  const tokens = splitMedicationTokens(value);
  const selected = [];
  const catalogKeys = new Map(
    catalogNames.map((name) => [normalizeMedicationKey(name), name])
  );
  tokens.forEach((token) => {
    const key = normalizeMedicationKey(token);
    const matched = catalogKeys.get(key) || catalogNames.find((name) => name === token);
    if (matched && !selected.includes(matched)) {
      selected.push(matched);
    }
  });
  return selected;
};
